import classNames from 'classnames';
import React from 'react';
import { Alert } from 'react-bootstrap';

import './hui-alert.scss';
import { HUIAlertProps } from './types';

const HUIAlert: React.FC<HUIAlertProps> = ({ className, children, icon, ...props }) => {
  const defaultIconClassName = {
    danger: 'pgicon pgicon-warning-o',
    warning: 'pgicon pgicon-warning-o',
  };

  return (
    <Alert className={classNames('hui-alert-root', className)} {...props}>
      {icon && <i {...icon} />}
      {!icon && props.variant && <i className={defaultIconClassName[props.variant]} />}
      {children}
    </Alert>
  );
};

export default HUIAlert;
